import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Widget } from '../../service/Interface/SiteDashboard.interface';
import { ConditionMonitoringDisplay, ConditionMonitoringDisplayType, ConditionMonitoringWidget, ConditionMonitoringWidgetResult } from '../../service/Interface/Widget.interface';
import { WidgetRxjsService } from '../../service/rxjs/WidgetRxjs.service';
import { WidgetConstant } from '../../service/widgetHelper/WidgetConstant';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'widget-condition-monitoring',
    templateUrl: './condition-monitoring.component.html',
    styleUrls: [
        './../../site-dashboard.component.scss',
        './condition-monitoring.component.scss',
    ],
})
export class SiteDashboardConditionMonitoringComponent implements OnInit, OnDestroy {
    private onDestroy = new Subject<void>();

    public displayResult: ConditionMonitoringWidgetResult;
    //TODO: Add Transform Ui
    public siteDashboardWidgetId: string;
    public displayBySelectionList: Array<ConditionMonitoringDisplay>;
    public selectedDisplayBy: ConditionMonitoringDisplay;
    public resultItem: ConditionMonitoringWidget;
    public resultSubscription: Subscription;

    constructor(
        private widgetRxjs: WidgetRxjsService,
        private widgetConstant: WidgetConstant,
    ) {
        this.displayBySelectionList = this.widgetConstant.getConditionMoinotringSelectionList();
        
    }

    @Input() set getWidgetDetail(widget: Widget) {
        this.siteDashboardWidgetId = widget.siteDashboardWidgetId;
    }

    ngOnInit() {
        this.getConditionMonitoringWidgetResult();
    }

    ngOnDestroy() {
        this.resultSubscription.unsubscribe();
        this.onDestroy.next();
        this.onDestroy.complete();
    }

    /**Set Condition Moniotring Result*/
    private getConditionMonitoringWidgetResult() {
        //Subscribe API(s) Call
        this.resultSubscription = this.widgetRxjs.conditionMonitoringWidget.pipe(
            takeUntil(this.onDestroy),
        ).subscribe((widgets) => {
            const conditionMonitoringWidget = widgets?.find(({siteDashboardWidgetId}) =>siteDashboardWidgetId === this.siteDashboardWidgetId);
            if (!!conditionMonitoringWidget) {
                this.resultItem = conditionMonitoringWidget;
                this.setDefaultSelectedDisplayBy();
            }
        });
    }

    private updateDisplayTable() {
        let result: ConditionMonitoringWidgetResult;
        switch(this.resultItem.displayBy) {
            case ConditionMonitoringDisplayType.ActionStatus:
                result = this.resultItem.result?.actionStatus;
                break;
            case ConditionMonitoringDisplayType.LastInspectedDate:
                result = this.resultItem.result?.lastInspectedDate;
                break;
            case ConditionMonitoringDisplayType.RecommendedAction:
                result = this.resultItem.result?.recommendedAction;
                break;
            default:
                result = [];
        }
        this.displayResult = result;
    }

    /**Set Default Selection */
    setDefaultSelectedDisplayBy() {
        this.selectedDisplayBy = this.displayBySelectionList.find((selection) => selection.sequence === this.resultItem.displayBy);
        if (!!this.selectedDisplayBy && !!this.resultItem?.result) {
            this.updateDisplayTable();
        }
    }

    /**Change the Condition Moniotring for display By*/
    onChangeDisplayBy(selectedAction: ConditionMonitoringDisplay) {
        this.resultItem.displayBy = selectedAction.sequence;
        this.updateDisplayTable();
    }
}